export const mapURLSearchParamsToQuery = searchParams => {
  const keys = searchParams.keys();
  const query = {};
  for (const key of keys) {
    const values = searchParams.getAll(key);
    switch (values.length) {
      case 0:
        query[key] = undefined;
        break;
      case 1:
        query[key] = values[0];
        break;
      default:
        query[key] = values;
    }
  }
  return query;
};